
export const imgOneAnims = {
    initial: {
        x: '-100%',
        // scale: 0.9

    },
    variants: {
        beginning: {
            x: 0,
            // scale: 1,

            transition: {
                x: { duration: 1.05, delay: .93, ease: 'easeInOut' },
                // scale: { duration: 1.05, delay: .93, ease: 'easeInOut' },
            }
        },
        end: {
            x: '100%',
            transition: {
                x: { duration: 1.05, ease: 'easeInOut' },
            }
        },
    },

}

export const imgTwoAnims = {
    initial: {
        x: '-100%',
        // scale: 0.9
    },
    variants: {
        beginning: {
            x: 0,
            // scale: 1,

            transition: {
                x: { duration: .9, delay: .66 },
                scale: { duration: .9, delay: .66 }
            }
        },
        end: {
            x: '100%',
            transition: {
                x: { duration: 1.05, ease: 'easeInOut' },
            }
        },
    }
}

export const imgThreeAnims = {
    initial: {
        x: '-100%',
        // scale: .9
    },
    variants: {
        beginning: {
            x: 0,
            // scale: 1,

            transition: {
                x: { duration: .8, delay: .3 },
                // scale: { duration: .8, delay: .3 }
            }
        },
        end: {
            x: '100%',
            transition: {
                x: { duration: 1.05, ease: 'easeInOut' },
            }

        },
    }
}